var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldPartnerMedallion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GoldPartner-medallion",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 71.079,
    viewBox: "0 0 50 71.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31932",
    "data-name": "Rectangle 31932",
    width: 50,
    height: 71.079,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40676",
    "data-name": "Path 40676",
    d: "M86.8,132.715a24.979,24.979,0,0,0,37.17-33.378,25.564,25.564,0,0,0-1.861-1.867L86.8,132.721Z",
    transform: "translate(-86.8 -97.47)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40677",
    "data-name": "Path 40677",
    d: "M85.52,114.733a19.831,19.831,0,1,0,19.825-20.3,20.071,20.071,0,0,0-19.825,20.3",
    transform: "translate(-85.52 -94.43)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platinum_Partner_medallion_small",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15117",
    d: "M115.385,50.26,105.84,68.434h14.1L129.6,50.26H115.385Z",
    transform: "translate(-88.302 -50.26)",
    fill: "#b0b0af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12265",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14187",
    "data-name": "Group 14187",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12264",
    transform: "translate(0 15.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15118",
    d: "M118.913,77.38h-2.094a.659.659,0,0,0-.659.659h0v1.593a1.006,1.006,0,0,1-1.009,1.009h-12.2a1.006,1.006,0,0,1-1.009-1.009h0V78.039a.659.659,0,0,0-.659-.659h-2.27a.651.651,0,0,0-.63.467L95.43,87.4h27.077l-2.952-9.557a.664.664,0,0,0-.63-.467",
    transform: "translate(-83.966 -77.38)",
    fill: "#e9bb10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15119",
    d: "M100.78,86.44a25,25,0,0,0-18.571,41.739l35.309-35.309A24.885,24.885,0,0,0,100.78,86.44",
    transform: "translate(-75.78 -81.154)",
    fill: "#c9971b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12267",
    transform: "translate(6.429 27.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14188",
    "data-name": "Group 14188",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12266",
    transform: "translate(0 -0.006)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4149",
    width: 46.394,
    height: 46.365,
    fill: "#d5aa41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12269",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14189",
    "data-name": "Group 14189",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12268",
    transform: "translate(4.662 25.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15121",
    d: "M104.108,94.43a20.3,20.3,0,1,1-20.338,20.3,20.3,20.3,0,0,1,20.338-20.3h0",
    transform: "translate(-83.77 -94.43)",
    fill: "#fdcf1f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12271",
    transform: "translate(5.683 25.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14190",
    "data-name": "Group 14190",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12270",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4151",
    width: 39.656,
    height: 40.607,
    fill: "#e9bb10"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14191",
    "data-name": "Group 14191",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12272",
    transform: "translate(6.744 0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15123",
    d: "M112.754,68.459h-14.1L87.34,50.32h14.323Z",
    transform: "translate(-87.34 -50.32)",
    fill: "#57a932"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40678",
    "data-name": "Path 40678",
    d: "M109.92,135.132l-6.1-10.566L97.72,114h24.4l-6.1,10.566-6.1,10.566Z",
    transform: "translate(-84.92 -76.812)",
    fill: "#c9971b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40679",
    "data-name": "Path 40679",
    d: "M111.032,134.467l-5.566-9.638L99.9,115.19h22.258l-5.566,9.638-5.56,9.638Z",
    transform: "translate(-85.828 -77.308)",
    fill: "#fdcf1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldPartnerMedallion);
export default __webpack_public_path__ + "static/media/GoldPartner-medallion.6188e256c3985a00177152d4df5ea772.svg";
export { ForwardRef as ReactComponent };